import React, { Component } from "react";
import {HiMinusSm, HiPlus, HiTrash} from "react-icons/hi";
import { changeQuantity } from "../../services/services";
import { apiCartChangeProductQuantity } from "../../../features/shop/cart/services";

class ChangeQuantityBtn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      cartMode: props.cartMode, // cart mode is true if we are in the cart page
    };
  }

  change_quantity_in_cart_mode(quantity) {
    apiCartChangeProductQuantity(
      this.props.shopUid,
      this.props.product.id,
      quantity
    ).then((data) => {
      data &&
        this.setState({ pending: false }, () =>
          this.props.quantityChanged(data)
        );
    });
  }

  change_quantity_in_shop_mode(quantity) {
    changeQuantity(this.props.shopUid, this.props.product.id, quantity).then(
      (data) => {
        this.setState({ pending: false }, () =>
          this.props.quantityChanged(data)
        );
      }
    );
  }

  change_quantity(mode) {
    this.setState({ pending: true });
    let quantity = this.props.quantity;
    if (mode === "increase") {
      quantity++;
    } else {
      if (quantity === this.props.product.min_quantity) {
        quantity = 0;
      } else {
        quantity--;
      }
    }

    if (this.state.cartMode) {
      this.change_quantity_in_cart_mode(quantity);
    } else {
      this.change_quantity_in_shop_mode(quantity);
    }

    if (quantity === 0) {
      this.close()
    }
  }

  render() {
    return (
      <span
        className="rounded28 border p-0 row mx-0 text-center"
        style={{ width: "90px", height: "40px" }}
      >
        <button
          className="btn col p-0 align-self-center color-second"
          disabled={this.state.pending}
          onClick={() => this.change_quantity("increase")}
        >
          <HiPlus size="20" />
        </button>

        <div className="col-auto px-0 align-self-center">
          {this.state.pending ? (
            <span className="spinner-border spinner-border-sm color-second align-middle" />
          ) : (
            <span>{this.props.quantity}</span>
          )}
        </div>
        <button
          className="btn col p-0 align-self-center color-second"
          disabled={this.state.pending || this.props.quantity < 1}
          onClick={() => this.change_quantity("decrease")}
        >
          {(this.props.quantity === this.props.product.min_quantity) && (<HiTrash size="24" />)}
          {(this.props.quantity !== this.props.product.min_quantity) && (<HiMinusSm size="24" />)}
        </button>
      </span>
    );
  }
}

ChangeQuantityBtn.defaultProps = {
  cartMode: false,
};

export default ChangeQuantityBtn;
